<template>
  <base-list-overview
    controller="Monitor"
    :filter="Filter"
    redirect
    redirect-page="Monitors"
    tab="monitors"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'CarePartnersMonitors',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ],
  computed: {
    Filter () {
      const key = 'idCarePartner'
      return [
        {
          key: key,
          value: this.ContentMixin_Element[key]
        }
      ]
    }
  }
}
</script>
